import React from 'react';

import FaqItem, { type FaqItemProps } from './FaqItem';

type FaqSectionProps = {
  faqData: FaqItemProps[];
};

export default function FaqSection({ faqData }: FaqSectionProps) {
  return (
    <div id="faq-section" className="bg-rp-daylight w-full pt-16">
      <div className="mx-4 d:mx-122 flex flex-col gap-6">
        {faqData.map((faq, index) => (
          <FaqItem key={`item-${index.toString()}`} content={faq.content} title={faq.title} />
        ))}
      </div>
    </div>
  );
}
